module.exports = __webpack_public_path__ + "d08158709f0fb8543824debe4c0eeab5.png";